import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {HttpStatusCode} from "@angular/common/http";
import {CurrencyPipe} from "@angular/common";
import {CustomMessageService, ResponseHttpError, ResponseHttpSuccess, UtilService} from "library";
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {PathNavigationService} from 'projects/store/src/app/services/api/v1/path-navigation.service';
import {environment} from "../../../../environments/environment";
import {SalesWorkflowService} from "projects/store/src/app/services/api/v1/sales-workflow.service";

enum Section {
  product = 'product',
  quote = 'quote',
  summary = 'summary',
}

@Component({
  selector: 'app-sales-credit-setup',
  templateUrl: './sales-credit-setup.component.html'
})
export class SalesCreditSetupComponent implements OnInit {
  requestId: string;
  products!: any[];
  selectedPrice!: number;
  selectedProduct: any;
  selectedQuote: any;
  minPrice = 1000000000
  maxPrice = 0;
  prices: number[] = [];
  country = environment.global.country;
  section: string = Section.product;
  protected readonly Section = Section;
  flowCode = this.route.snapshot.params['flow_code'];
  @Output() nextStepEvent = new EventEmitter();

  constructor(private requestService: RequestService,
              private route: ActivatedRoute,
              private router: Router,
              private utilService: UtilService,
              private customMessageService: CustomMessageService,
              private currencyPipe: CurrencyPipe,
              private salesWorkflowService: SalesWorkflowService,
              private pathNavigationService: PathNavigationService) {
    this.requestId = this.route.snapshot.params['request_id']
  }

  ngOnInit() {
    this.load();
  }

  load() {
    this.utilService.enablePageLoading();
    this.requestService.getProductsByCategory(this.requestId, this.requestService.categoryId).subscribe({
      next: (resp: ResponseHttpSuccess)=> {
        if(resp.status === HttpStatusCode.Ok) {
          this.products = resp.body.data.list;
          if(this.products.length === 0) {
            setTimeout(()=> this.router.navigate([this.salesWorkflowService.getErrorNotApprovedRequestUrl()]), 0);
          }
          this.extractMinMaxPrices();
        }else{
          this.customMessageService.responseNoticeHandler(resp);
          this.utilService.disablePageLoading();
        }
      },
      error: (error: ResponseHttpError) => {
        this.customMessageService.responseNoticeHandler(error);
        this.utilService.disablePageLoading();
      }
    });
  }

  extractMinMaxPrices() {
    this.products.forEach((row: any) => {
      row.quotes.forEach((row1: any) => {
        this.minPrice = row1.prices.suggested < this.minPrice ? row1.prices.suggested : this.minPrice;
        this.maxPrice = row1.prices.suggested > this.maxPrice ? row1.prices.suggested : this.maxPrice;

        if( ! this.prices.includes(row1.prices.suggested)) {
          this.prices.push(row1.prices.suggested);
        }
        if(row1.prices.suggested == this.maxPrice) {
          this.selectedProduct = row;
        }
      });
    });
    this.selectedPrice = this.maxPrice;
    this.utilService.disablePageLoading();
  }

  save() {
    let data = { product: this.selectedProduct, quotes: this.selectedQuote};
    this.requestService.update(this.requestId, data).subscribe({
      next: (resp: ResponseHttpSuccess)=> {
        if(resp.status === HttpStatusCode.NoContent) {
          this.onNextStep();
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
      },
      error: (error: ResponseHttpError) => {
        if ( error.status === HttpStatusCode.Locked) {
          this.handleRequestLocked(error as any);
        }else{
          this.customMessageService.responseNoticeHandler(error);
        }
      }
    });
  }

  getProductByPrice(price: number) {
    let product = null;
    this.products.forEach((row: any) => {
      row.quotes.forEach((row1: any) => {
        if(row1.prices.suggested === price) {
          row.quotes.sort((a: any, b: any) => a.quota.quantity - b.quota.quantity);
          product = row;
        }
      });
    });
    return product;
  }

  getLabelProduct(quote: any) {
    return `En <strong>${quote.quota.quantity} cuotas</strong> y pagaré <strong>${this.currencyPipe.transform(quote.quota.from)}</strong>`
  }

  onSlideEnd(price: any) {
    if( ! this.prices.includes(price)) {
      let previousPrice = this.selectedProduct.quotes[0].prices.suggested
      // TODO mejorar, deberia detenerse cuando se cumpla la condicion
      let priceTemp: any;
      if(price < previousPrice) {
        this.prices.sort((a: any, b: any) => b - a).forEach(row => {
          if(row < price && priceTemp == undefined) {
            priceTemp = row;
          }
        });
      }else{
        this.prices.sort((a: any, b: any) => a - b).forEach(row => {
          if(row > price && priceTemp == undefined) {
            priceTemp = row;
          }
        });
      }

      if(priceTemp) {
        this.selectedPrice = priceTemp;
      }
    }
    this.selectedProduct = this.getProductByPrice(this.selectedPrice);
  }

  onSelectedProduct() {
    this.selectedProduct = this.getProductByPrice(this.selectedPrice);
    if(this.selectedProduct !== null) {
      this.section = Section.quote;
    }
  }

  onSelectedQuote(quote: any) {
    // TODO mover a un metodo cuando la categoria sea distinta a kredicash
    quote.installment.selected = quote.installment.from;
    quote.prices.selected = quote.prices.suggested;
    quote.quota.selected = quote.quota.from;

    this.selectedQuote = quote;
  }

  frequencyText(): string {
    return this.utilService.getFrequencyDescription(this.selectedQuote.frecuency);
  }

  onConfirmSelectedQuote() {
    this.section = Section.summary;
  }

  newCreditSetup() {
    this.selectedQuote = null;
    this.section = Section.product;
  }

  onNextStep() {
    this.nextStepEvent.emit();
  }

  private handleRequestLocked(resp: any): void {
    const messageError = resp.error?.message ?? 'Solicitud no disponible';
    const attemptedUrl = this.utilService.getCurrentUrl();
    const state = { attemptedUrl, messageError };

    this.pathNavigationService.navigateToRequestNotAvailable(this.flowCode, state);
  }
}
